import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';

const EmptyLandingPageComponent = props => {
  const {
    search
  } = props.location;
  const searchSplit = search.split('otpPage=');
  const otpPage = searchSplit[searchSplit.length - 1];
  useEffect(() => {
    window.location.href = decodeURIComponent(otpPage);
  }, [otpPage]);
  return /*#__PURE__*/_jsx("div", {});
};

export default EmptyLandingPageComponent;